import {
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    updateProfile
} from "firebase/auth";
import { auth, db } from "../firebase/config";
import { doc, getDoc, setDoc } from "firebase/firestore";

/**
 * Ensure a Firestore user doc exists
 * @param {object} user // Firebase Auth user object
 * @param {string} provider // "email" or "google"
 * @param {string} name // optional display name
 */

const createUserDocIfNotExists = async (user, provider, name = "") => {
    const userRef = doc(db, "users", user.uid);
    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) {
        await setDoc(userRef, {
            name: name || user.displayName || "",
            email: user.email,
            createdAt: new Date(),
            provider,
        });
    }
};

// Email/password signup
export const signup = async (email, password, name) => {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    if (name) {
        await updateProfile(user, { displayName: name });
    }

    await createUserDocIfNotExists(user, "email", name);
    return user;
};

// Email/password login
export const login = async (email, password) => {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    await createUserDocIfNotExists(user, "email");
    return user;
};

// Google SSO login helper
export const loginWithGoogle = async (googleUser) => {
    await createUserDocIfNotExists(googleUser, "google");
    return googleUser;
};
